import React from 'react';
import { createRoot } from 'react-dom/client';
import RevenueCalculator from 'components/RevenueCalculator';

const parseJson = (value, fallback) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    console.error('RevenueCalculator: could not parse container data', error);
    return fallback;
  }
};

function mountCalculator(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const props = {
    initialCalculation: parseJson(container.dataset.initialCalculation, null),
    showComparison: container.dataset.showComparison === 'true',
    feeLabels: parseJson(container.dataset.feeLabels, {})
  };

  createRoot(container).render(<RevenueCalculator {...props} />);
}

document.addEventListener('DOMContentLoaded', () => {
  mountCalculator('revenue-calculator');
  mountCalculator('revenue-calculator-homepage');
  mountCalculator('revenue-calculator-for-teachers');
  mountCalculator('revenue-calculator-tool');
});
